'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidCalendar = function IoAndroidCalendar(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 21.3v7.5h-7.5v-7.5h7.5z m-2.5-16.3h3.7v2.5h1.9c1.7 0 3.1 1.4 3.1 3.1v21.3c0 1.7-1.4 3.1-3.1 3.1h-23.8c-1.7 0-3.1-1.4-3.1-3.1v-21.3c0-1.7 1.4-3.1 3.1-3.1h1.9v-2.5h3.8v2.5h12.5v-2.5z m5.6 26.9v-16.6h-23.8v16.6h23.8z' })
        )
    );
};

exports.default = IoAndroidCalendar;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-calendar.js
// module id = 1826
// module chunks = 0